
  export const delay = (delay: number) => {
    return new Promise((r) => {
      setTimeout(r, delay);
    });
  };